import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const GeneralSection = ({ data }) => (
  <DescriptionList disableGutters data={data} termWidth={'30%'}>
    <DescriptionItem label={'Address line 1'} field={'address.streetAddress'} />
    <DescriptionItem
      label={'Address line 2'}
      field={'address.streetAddress2'}
    />
    <DescriptionItem label={'City'} field={'address.city'} />
    <DescriptionItem
      label={'State / Province / Region'}
      field={'address.region'}
    />
    <DescriptionItem label={'Zip / Postal code'} field={'address.postalCode'} />
    <DescriptionItem label={'Country'} field={'address.country'} />
    <DescriptionItem label={'Time zone'} field={'timeZone'} />
  </DescriptionList>
);

export default GeneralSection;
